import App_data from "../views/config/App_data";

class ApiService {


    constructor() {
        this.apiEndpoint = App_data.backend_api;
        this.authHeader = null;
    }

    setAuthHeader(token) {
        this.authHeader = {
            'Authorization': `${token}`
        }
        return this;
    }

    serializeUrl(obj){
        return Object.entries(obj).map(([key, val]) => `${key}=${val}`).join('&')
    }

    buildEndpointUrl(options) {
        const query = options.query != null ? options.query : null;
        const path = options.path;
        const queryParams = query != null ? this.serializeUrl(query) : null
        const reqString = `${this.apiEndpoint}${path != null ? `/${path}` : ''}${queryParams != null && queryParams.length > 0 ? `?${queryParams}` : ''}`.trim()
        return reqString.replace(/([^:]\/)\/+/g, "$1")
    }

    async __fetchRequest(url, method, data, headers = {}) {
        const normalizedMethod = method.toUpperCase();

        const options = {
            method: normalizedMethod,
            headers: {
                'Accept': 'application/json',
                ...headers,
            },
        };

        const beOptions = { path: url };

        if (data != null && normalizedMethod === 'POST') {
            options.body = JSON.stringify(data);
            options.headers['Content-Type'] = 'application/json';
        }

        if (data != null && normalizedMethod === 'GET') {
            beOptions.query = data;
        }

        if (this.authHeader != null) {
            options.headers = {
                ...options.headers,
                ...this.authHeader,
            };
        }

        const response = await fetch(this.buildEndpointUrl(beOptions), options);

        if (!response.ok) {
            const text = await response.text();
            throw new Error(`HTTP ${response.status}: ${text}`);
        }

        return await response.json();
    }

    async get(url, query, headers) {
        return await this.__fetchRequest(url, 'GET', query, headers);
    }

    async post(url, data, headers) {
        return await this.__fetchRequest(url, 'POST', data, headers);
    }

}

export default ApiService;



// WEBPACK FOOTER //
// ./src/services/ApiService.js